<div class="w-full bg-white">
     <!-- Header -->
     <div class="flex flex-row  justify-between items-center py-3 mx-2 md:mx-8 border-b">

        <!-- Title -->
        <div class="flex flex-row items-start md:items-center">
            
            <div class="flex items-center">
                <arrow-back></arrow-back>
                <mat-icon class="icon-size-14 mx-1 md:mx-4 text-gray-400" [svgIcon]="'account_balance'"></mat-icon>
            </div>
            <div>
                <div class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl">Listado De Bienes Culturales y Coloniales</div>
                <div class="ml-0.5 font-medium text-secondary mt-1">Bienes Culturales</div>
            </div>
        </div>

    </div>
    <filtro-listado-bienes></filtro-listado-bienes>
    <div class="mx-0 md:mx-8 mt-4">
        <lista-bienes [dataSource]="bienesCulturales$ | async"></lista-bienes>
    </div>

</div>